<template>
  <div class="topdiv">
      <router-link to="/index"><img class="logo2" src="@/assets/logo2.png"></router-link>
      <div class="title">医学科研管理系统</div>
      <div class="tag" v-if="usertype=='1'">个人学术版</div>
      <div class="tag" v-if="usertype=='2'">机构学术版</div>
      <div class="tag" v-if="usertype=='3'">商业学术版</div>
      <div class="infortext" v-if="usertype!='1'">当前余额:<strong style="color:#2397CA">￥{{piduserinfo?piduserinfo.money:userInfo.money}}</strong>，授权到期:{{timeformat(piduserinfo?piduserinfo.sqendtime:userInfo.sqendtime)}}</div>
       <div class="menu">
        <router-link to="/index" class="header-btn">首页</router-link>
        <router-link to="/create" class="header-btn">创建新方案</router-link>
        <router-link to="/orderlist" class="header-btn">我的订单</router-link>
        <router-link v-if="usertype=='1'" to="/fapiao" class="header-btn">发票管理</router-link>
        <router-link to="/infor" class="header-btn">修改个人资料</router-link>
      </div>
      <div class="topright">{{piduserinfo?piduserinfo.jggs+' | ':''}}{{realname}}，欢迎您   <span class="tui" @click="out">退出</span></div>
  </div>

</template>

<script>
import { refreshUser,logout } from "@/api/index.js"
export default {
  name: "Header",
  data(){
    return {
     
    }
  },
  computed: {
    piduserinfo(){
return  this.$store.state.piduserinfo
    },
    realname() {
      return  this.$store.state.realname
    },
    usertype(){
       return  this.$store.state.usertype
    },
    userInfo(){
      return  this.$store.state.userInfo
    }
  },
  mounted(){
    refreshUser().then(res=>{
      if(res.code==1){
             this.$store.commit("login",res.data)
       }
       
    })
  },
  methods: {
    timeformat(timestamp){
      const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
    },
    out(){
      this.$confirm('确定要退出该账号吗？', '退登确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(()=>{
        // 清除账户状态记录
        logout()
        this.$store.commit("logout");
        // 跳转到登录页面
        this.$router.push("/");
        this.$notify({
          title: '成功',
          message: '账号已退出',
          type: 'success'
        });
      })
    }
  }
};
</script>

<style lang="less">
.topdiv {
  min-width: 1200px;
  height:50px;background:#F4F8FC;padding:10px;display: flex;align-items:center;
  .logo2 {height:40px;width:44px;}
  .title {font-size: 22px;font-weight: 500;margin-left:10px;}
  .tag {margin-left:10px;background:#2397CA;color:#fff;font-size: 12px;height:28px;line-height: 28px;border-radius: 16px;padding-left:10px;padding-right:10px;}
  .menu {font-size:18px;color:#333;margin-left:70px;flex:1;
    a {
      margin-right:30px;color:#333;
    }
    a:hover, .router-link-active {color:#2397CA;font-weight: bold}
    
  }
  .topright {
    font-size:16px;
    .tui {
      color:#002855;margin-left:10px;cursor: pointer;
    }
     .tui:hover,.tui2:hover {text-decoration: underline} 
  }
  .infortext {margin-left:20px;}
}

</style>
